import React, { useState } from "react";
import * as buttonStyles from "./buttonComponent.module.scss";
import cursor from "../../../images/home/button-arrow.svg";
import { Loader } from '@mantine/core';

export default function ButtonComponent({
  buttonText,
  type,
  buttonStyle,
  onClick,
  disabled,
  loading,
  className,
}) {
  const getButtonStyleFromType = (styleType) => {
    switch (styleType) {
      case "solidBg":
        return {
          backgroundColor: "#E40A65",
          color: "#ffffff",
          fontWeight: "400",
          fontSize: "18px",
          padding: "5px 5px 5px 30px",
        };
      case "header":
        return {
          backgroundColor: "#E40A65",
          color: "#ffffff",
          fontWeight: "400",
          padding: "5px 5px 5px 40px",
          fontSize: "24px",
        };

      default:
        return {
          backgroundColor: "transparent",
          color: "#E40A65",
          fontWeight: "600",
          fontSize: "16px",
        };
    }
  };

  const getButtonCursorStyleFromType = (styleType) => {
    switch (styleType) {
      case "solidBg":
        return {
          backgroundColor: "#B00C51",
          width: "50px",
          height: "50px",
        };
      case "header":
        return {
          backgroundColor: "#B00C51",
          width: "67px",
          height: "68px",
        };
      default:
        return {
          backgroundColor: "#E40A65",
        };
    }
  };

  const getButtonCursorImageStyleFromType = (styleType) => {
    switch (styleType) {
      case "solidBg":
        return {
          width: "13.11px",
          height: "11.59px",
        };
      case "header":
        return {
          width: "15.91px",
          height: "14.07px",
        };
      default:
        return {
          width: "13.11px",
          height: "11.59px",
        };
    }
  };

  const [position, setPosition] = useState({ x: 0, y: 0 });

  const cursorId = `cursorNew-${Math.random().toString(36).substring(2, 15)}`;

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;

    setPosition({ x: `${x * 0.1}px`, y: `${y * 0.2}px` });

    const customCursor = document.querySelector(`#${cursorId}`);
    if (customCursor) {
      customCursor.style.left = `${e.clientX - rect.left - 30}px`;
      customCursor.style.width = "25%";
      customCursor.style.height = "85%";
      customCursor.style.top = `${e.clientY - rect.top - 30}px`;
    }
  };

  const handleMouseEnter = () => {
    const customCursor = document.querySelector(`#${cursorId}`);
    if (customCursor) {
      customCursor.style.display = "block";
    }
  };

  const handleMouseLeave = () => {
    setPosition({ x: 0, y: 0 });
    const customCursor = document.querySelector(`#${cursorId}`);
    if (customCursor) {
      customCursor.style.display = "none";
    }
  };

  return (
    <button
      disabled={disabled}
      className={`${buttonStyles.button} ${className} button-container`}
      style={{
        transform: `translate(${position.x}, ${position.y})`,
        ...getButtonStyleFromType(buttonStyle),
        cursor: `${disabled ? 'not-allowed' : 'pointer'}`,
      }}
      type={type}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      <div
        className={buttonStyles.button__buttonText}
        style={{
          transform: `translate(${position.x}, ${position.y})`,
        }}
      >
        {buttonText}
      </div>
      <div
        className={buttonStyles.button__buttonImageBox}
        style={{
          transform: `translate(${position.x}, ${position.y})`,
          ...getButtonCursorStyleFromType(buttonStyle),
        }}
      >
        {loading && <Loader size={24} color="#fff" />}
        {!loading && <img src={cursor} alt="cursor" className={buttonStyles.button__buttonImage} style={{ getButtonCursorImageStyleFromType }} width="17" height="15" />}
      </div>
      <div
        id={cursorId}
        className={`${buttonStyles.button__cursor} cursorNew`}
      ></div>
    </button>
  );
}
